import { Grid, Typography } from '@mui/material';
import React from 'react';
import { IConfig } from '../../../../../../Interfaces/IConfig';
import { ILandRegisterQueryRelationshipData } from '../../../../../../Interfaces/ILegalTransactionRelationship/Relationships/LandRegisterQuery/IReasonLandRegisterQuery';
import { ILegalTransactionRelationshipRealEstate } from '../../../../../../Interfaces/ILegalTransactionRelationship/Relationships/RealEstate/ILegalTransactionRelationshipRealEstate';
import { CustomeTextField } from '../../../../../generic/CustomeTextField';
import { RealEstateAddress } from '../../../PurchaseContract/Components/RealEstate/RealEstateAddress';
import { RealEstateLandRegister } from '../../../PurchaseContract/Components/RealEstate/RealEstateLandRegister';

interface IProps {
  configObject: IConfig;
  realEstate: ILegalTransactionRelationshipRealEstate;
  setRealEstate: Function;
  editReason: ILandRegisterQueryRelationshipData;
  setEditReason: Function;
}

export const EditLandRegisterQueryOverview: React.FC<IProps> = ({
  configObject,
  realEstate,
  setRealEstate,
  editReason,
  setEditReason,
}) => {
  return (
    <>
      <RealEstateAddress
        configObject={configObject}
        currentObject={realEstate}
        setCurrentObject={setRealEstate}
        marginTop={0}
      />

      <RealEstateLandRegister
        currentObject={realEstate}
        setCurrentObject={setRealEstate}
        marginTop={5}
      />

      <Grid container spacing={2} sx={{ mt: 5 }}>
        <Grid item xs={12}>
          <Typography variant='h5'>Berechtigtes Interesse</Typography>
        </Grid>
        <Grid item xs={12}>
          Das Grundbuch enthält sensible Informationen zu Eigentumsverhältnissen
          und Belastungen von Grundstücken. Aus datenschutzrechtlichen Gründen
          darf ein Auszug nur erteilt werden, wenn ein nachvollziehbares und
          rechtlich anerkanntes Interesse besteht (z. B. als Eigentümer, Käufer,
          Mieter, Gläubiger oder im Rahmen eines gerichtlichen Verfahrens).
          <br />
          Im nächsten Schritt haben Sie zudem die Möglichkeit, zur Unterstützung
          Ihrer Angaben relevante Dokumente hochzuladen.
        </Grid>
        <Grid item xs={12}>
          <CustomeTextField
            attr='Reason'
            label='Begründung'
            object={editReason}
            setObject={setEditReason}
            type='string'
            rows={3}
            required
          />
        </Grid>
      </Grid>
    </>
  );
};
